import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { validateForm } from "utils/validation";
import { RosterRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddRosterForm from "./Componates/AddRosterForm";
import fieldsJson from "../json/RosterFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { CreateRoster, getAllshift } from "adminApi/DutyRosterApi/RosterApi";
import useFetchAllData from "Hooks/useFetchAllData.js";


const AddRoster = () => {
    const navigate = useNavigate();

    const allFields = useMemo(() => fieldsJson.formFields, []);

    const { data: ShiftOptions, loading: loadingShift } = useFetchAllData(getAllshift);

    const initialValues = useMemo(() => {
        return allFields.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [allFields]);

    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        RosterRules
    );

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            // In this app, many POSTs use form-data but for basic JSON we can pass it directly
            // Adjusting to raw formValues since no files are attached.
            // If server demands FormData:
            // const formData = new FormData();
            // Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            // return await CreateRoster({ data: formData });

            return await CreateRoster({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, RosterRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Duty Roster Created successfully!"
    );


    return (
        <>
            {(loadingSubmit || loadingShift) && <Spinner isSpinner={true} />}
            <AddRosterForm
                fields={allFields}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Duty Roster"
                shiftsOptions={ShiftOptions}
            />
        </>
    );
};

export default AddRoster;
